// Module
var code = "<div ng-class=\"{'on': $ctrl.active === true, 'off': $ctrl.active === false}\" class=\"br-caption-2\"> {{$ctrl.active === true ? 'ON' : ($ctrl.active === false ? 'OFF' : 'Default') | translate}} </div> ";
// Exports
export default code;